import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    steps: [
      {
          index: 0,
          title: 'Choose Pattern',
          component: 'TilePattern'
      },
      {
          index: 1,
          title: 'Select Colors',
          component: 'TileColors'
      },
      {
          index: 2,
          title: 'Preview Layout',
          component: 'TileLayout'
      },
      {
          index: 3,
          title: 'Send',
          component: 'TileSubmit'
      }
    ],
    step: null,
    done: false,

    patterns: [],
    pattern: null,

    pallete: [],
    colors: {},
    image: null,

    layoutStyles: {},
    layoutImage: null,


    colorImage: null
  },
  mutations: {
    setDone(state, payload){
        state.done = payload;
    },
    setStep(state, payload){
        state.step = payload;
    },
    setPattern(state, payload){
        state.pattern = payload;
    },
    setPatterns(state, payload){
      state.patterns = payload;
    },
    setPallete(state, payload){
      state.pallete = payload;
    },
    setImage(state, payload){
        state.image = payload;
    },
    setLayoutImage(state, payload){
        state.layoutImage = payload;
    },
    setLayoutStyles(state, payload){
      state.layoutStyles = payload;
    },
    setColorImage(state, payload){
        state.colorImage = payload;
    },
    setColors(state, payload){
        state.colors = payload;
    }
  },
  actions: {
      next({state, commit}){
          let index = state.step.index + 1;

          if(index < state.steps.length){
              commit('setStep', state.steps[index]);
          }

          if(index == state.steps.length){

              if(state.done){
                  commit('setStep', state.steps[0]);
                  commit('setPattern', null);
                  commit('setColors', {});
                  commit('setDone', false);
              }else{
                  commit('setDone', true);
              }

          }

      },
      previous({state, commit}){
          let index = state.step.index - 1;

          if(index >= 0){
              commit('setStep', state.steps[index]);
          }

      },
      addColor({state, commit}, payload){
          let object = {};

          object[payload.vector] = payload;

          commit('setColors', Object.assign({}, state.colors, object));
      },
      addStyle({state, commit}, payload){

          let object = {};

          object[payload.id] = payload;

          commit('setLayoutStyles', Object.assign({}, state.layoutStyles, object));
      }
  }
})
